import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { isUndefined, omit } from '../../utils';
import { PurchaseMotionButtonPropsInterface, MergedPurchaseMotionProps } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionPropsInterface';
import { purchaseMotionButtons, purchaseMotionButtonPropsInterface } from 'ui-addon-upgrades/_core/common/constants/purchaseMotions';
import { UPGRADE_POINT_LOCATIONS } from 'ui-addon-upgrades/_core/common/constants/PurchaseMotionLocations';
import { getCanViewNewSeats } from '../common/eligibility/getCanViewNewSeats';
import ErrorBoundary from 'ui-addon-upgrades/ErrorBoundary';
import { mapPurchaseMotionApiName } from '../../ums/utils';

const PurchaseMotionButton = props => {
  const {
    upgradeData,
    trackingSource,
    purchaseMotions = [],
    level,
    passthroughProps = {},
    overrides = {},
    location
  } = props;
  const purchaseMotion = purchaseMotions[level - 1];
  const isUpgradePoint = location && UPGRADE_POINT_LOCATIONS.includes(location);
  const mappedButtonPassthroughProps = passthroughProps[purchaseMotion] || {};
  const mappedButtonPropsInterface = purchaseMotionButtonPropsInterface[purchaseMotion];
  const MappedButtonComponent = overrides[purchaseMotion] || purchaseMotionButtons[purchaseMotion];
  const [canViewNewSeats, setCanViewNewSeats] = useState(undefined);
  useEffect(() => {
    getCanViewNewSeats().then(res => {
      setCanViewNewSeats(res);
      upgradeData.apiName = mapPurchaseMotionApiName(res, upgradeData.upgradeProduct, 'purchaseMotion', upgradeData.apiName);
    }).catch(() => {
      setCanViewNewSeats(false);
    });
  }, [props, upgradeData]);

  if (isUndefined(MappedButtonComponent) || isUndefined(mappedButtonPropsInterface)) {
    return null;
  }

  const propsToKeep = [...Object.keys(mappedButtonPropsInterface), 'upgradeData', 'use'];
  const propsToOmit = Object.keys(omit(Object.assign({}, PurchaseMotionButtonPropsInterface, {}, MergedPurchaseMotionProps), propsToKeep));
  const propsToPass = omit(props, propsToOmit); // propsToPass needs to get the result from getCanViewNewSeats

  propsToPass.canViewNewSeats = canViewNewSeats;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "purchaseMotionButton",
    children: /*#__PURE__*/_jsx(MappedButtonComponent, Object.assign({
      "data-selenium-id": `${trackingSource}-${props.upgradeData.apiName}-${purchaseMotion}-button`,
      "data-reagan-primary-cta": true,
      truncate: true,
      isUpgradePoint: isUpgradePoint,
      level: level,
      canViewNewSeats: canViewNewSeats
    }, mappedButtonPassthroughProps, {}, propsToPass))
  });
};

PurchaseMotionButton.propTypes = PurchaseMotionButtonPropsInterface;
export default PurchaseMotionButton;